import React from 'react';
import { ChakraProvider, Box } from '@chakra-ui/react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home/Home';
import { Portfolio } from './pages/Portfolio/Portfolio';
import theme from './theme';
import { WalletProvider } from './contexts/WalletContext';
import { Footer } from './components/Footer';
import { ThemeProvider } from '@/kit/antipad-ui/ThemeProvider';
import '@/kit/antipad-fonts/index.css';
import './index.css';

console.log(process.env.REACT_APP_FIN_SERVICE_URL);
console.log(process.env.REACT_APP_NETWORK);

function App() {
  return (
    <ThemeProvider theme={null}>
      <ChakraProvider theme={theme}>
        <WalletProvider>
          <Router>
            <Box display="flex" flexDirection="column" minHeight="100vh">
              <Box flexGrow={1}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/portfolio" element={<Portfolio />} />
                </Routes>
              </Box>
              {/* <Footer /> */}
            </Box>
          </Router>
        </WalletProvider>
      </ChakraProvider>
    </ThemeProvider>
  );
}

export default App;
